
import { query_dispatcher, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";

export async function generateTextWithAI(prompt, output_schema = null, cheap = false, reason = false){
    const params = {
        prompt: prompt,
        output_schema: output_schema ? JSON.stringify(output_schema) : null,  // Serialize to JSON string
        cheap: cheap,
        reason: reason
    };
    return await async_command_dispatcher.dispatch_with_result("text.to.text.ai", params, 1000);
}